var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPmgd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.258423,
    y: 0.831421,
    width: 24.9438,
    height: 24.9438,
    rx: 12.4719,
    fill: "#828282"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3681 18.5133H5.09247L7.58685 6.5802H17.8737L20.3681 18.5133Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3679 18.5128V18.0139H5.70595L7.99082 7.07856H17.467L19.879 18.6151L20.3679 18.5128V18.0139V18.5128L20.8568 18.4106L18.3625 6.47741C18.3151 6.24543 18.1105 6.08081 17.8736 6.08081H7.58673C7.34976 6.08081 7.14771 6.24543 7.09782 6.47741L4.60344 18.4106C4.57351 18.5577 4.61093 18.7099 4.70572 18.8271C4.80051 18.9443 4.94268 19.0117 5.09235 19.0117H20.3679C20.5176 19.0117 20.6598 18.9443 20.7546 18.8271C20.8494 18.7099 20.8868 18.5577 20.8568 18.4106L20.3679 18.5128Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4678 6.56494L9.47 18.4482L10.4628 18.5305L11.4605 6.64725",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0023 6.64725L15.0001 18.5305L15.9929 18.4482L14.9951 6.56494",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5876 14.1508H5.78366V15.1486H19.5876",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5847 9.67078H6.83618V10.6685H18.5847",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6286 20.7077V20.2089H11.3335V19.0115H14.1297V20.7077H14.6286V20.2089V20.7077H15.1275V18.5127C15.1275 18.3805 15.0751 18.2533 14.9803 18.161C14.888 18.0687 14.7583 18.0138 14.6286 18.0138H10.8347C10.7025 18.0138 10.5753 18.0662 10.483 18.161C10.3907 18.2533 10.3358 18.383 10.3358 18.5127V20.7077C10.3358 20.8399 10.3882 20.9672 10.483 21.0595C10.5753 21.1517 10.705 21.2066 10.8347 21.2066H14.6286C14.7608 21.2066 14.888 21.1542 14.9803 21.0595C15.0726 20.9672 15.1275 20.8374 15.1275 20.7077H14.6286Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2423 20.2092H9.22059C8.9462 20.2092 8.72171 20.4337 8.72171 20.708C8.72171 20.9824 8.9462 21.2069 9.22059 21.2069H16.2423C16.5167 21.2069 16.7412 20.9824 16.7412 20.708C16.7412 20.4337 16.5167 20.2092 16.2423 20.2092Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmgd);
export default __webpack_public_path__ + "static/media/pmgd.83c097af4c13c63a6405335b101658ce.svg";
export { ForwardRef as ReactComponent };